import React, { createContext, useContext, useState, useCallback, useMemo } from 'react'
import en from '../locales/en.json'
import ru from '../locales/ru.json'

const messages = { en, ru }

function detectLang() {
  const stored = localStorage.getItem('lang')
  if (stored && messages[stored]) return stored
  if (window.location.hostname.startsWith('ru.')) return 'ru'
  const nav = navigator.language?.slice(0, 2)
  if (nav === 'ru') return 'ru'
  return 'en'
}

const LangContext = createContext()

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(detectLang)

  const setLang = useCallback((l) => {
    localStorage.setItem('lang', l)
    setLangState(l)
  }, [])

  const t = useCallback((key, params) => {
    const keys = key.split('.')
    let val = messages[lang]
    for (const k of keys) {
      val = val?.[k]
      if (val === undefined) break
    }
    if (val === undefined) return key
    if (typeof val !== 'string') return val
    if (params) {
      return val.replace(/\{(\w+)\}/g, (_, k) => params[k] ?? `{${k}}`)
    }
    return val
  }, [lang])

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t])

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>
}

export function useLang() {
  return useContext(LangContext)
}
